const AssetService = {

    // FIELDS
    "premise": "Premise",
    "asset": "Asset",
    "name": "Name",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "assetService": "Asset Service",

    // ERROR
    "error_premise": "Select Premise",
    "error_asset": "Select Asset",
    "error_name": "Enter Name",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_premise": "PREMISE",
    "table_asset": "ASSET",
    "table_name": "NAME",
    "table_status": "STATUS",

}

export default AssetService;